/**
 * This is here to share values between Layouts and pages becaus eNextJS does not allow for such a thing
 */
import { createSlice } from '@reduxjs/toolkit';
import type { AppRootState } from '@/configureStore';

interface AbusiveGlobalStoreState {
  [key: string]: any;
}

const initialState: AbusiveGlobalStoreState = {};

export const abusiveGlobalStoreSlice = createSlice({
  name: 'abusiveGlobalStore',
  initialState,
  reducers: {
    setValue: (state, { payload }: { payload: { key: string; value: any } }) => {
      const { key, value } = payload;
      if (value === undefined) {
        delete state[key];
      } else {
        state[key] = value;
      }
    }
  }
});

export const { setValue } = abusiveGlobalStoreSlice.actions;
export const selectValue = (state: AppRootState, valueName: string) => state.abusiveGlobalStore[valueName];
